import Vue from 'vue';
import { TYPE } from '@/components/base-components/components/message';
import BaseMessage from '@/components/base-components/components/message/base-message';

const list = [];

const GAP_SIZE = 16;
let seed = 1;

function mountMessage(props) {
    const vm = new Vue({
        render: h => h(BaseMessage, {
            props,
            ref: 'message',
        }),
    });

    vm.$mount();
    document.body.appendChild(vm.$el);

    const instance = vm.$refs.message;

    return {
        instance,
        unmount: () => {
            vm.$destroy();
            vm.$el.parentNode?.removeChild(vm.$el);
        },
    };
}

export function close(id, userOnClose) {
    const index = list.findIndex(instance => instance.id === id);

    if (index === -1) return;

    const instance = list[index];

    if (!instance) return;

    userOnClose?.();

    const removeHeight = instance.$el.offsetHeight;

    list.splice(index, 1);

    if (list.length < 1) return;

    for (let i = index; i < list.length; i++) {
        const item = list[i];

        item.offset = Number.parseInt(item.$el.style.top, 10) - removeHeight - GAP_SIZE;
    }
}

function message(params) {
    let options = params;

    if (typeof params === 'string') {
        options = { message: params };
    }

    let verticalOffset = options.offset || 0;

    list.forEach(({ $el }) => {
        verticalOffset += ($el?.offsetHeight || 0) + GAP_SIZE;
    });

    verticalOffset += GAP_SIZE;

    const id = `message_${seed}`;

    seed += 1;

    const userOnClose = options.onClose;

    const mounted = mountMessage({
        ...options,
        id,
        offset: verticalOffset,
        onClose: () => {
            close(id, userOnClose);
        },
        onDestroy: () => {
            mounted.unmount();
        },
    });

    list.push(mounted.instance);

    return {
        close: () => {
            mounted.instance.close?.();
        },
    };
}

Object.values(TYPE).forEach((type) => {
    message[type] = (params) => {
        let options = params;

        if (typeof params === 'string') {
            options = { message: params };
        }

        return message({
            ...options,
            type,
        });
    };
});

export default message;
